import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Image } from "react-shimmer";

interface Props {
  src: string;
  width: number;
  height: number;
  fallback: JSX.Element;
}

const CachedSignedImage = (props: Props) => {
  const actualUrl = props.src.split("?")[0];

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["cached-signed-image", actualUrl],
    queryFn: async () => {
      const response = await fetch(props.src);
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    },
    staleTime: Infinity,
  });

  if (query.isLoading) {
    return props.fallback;
  }

  if (query.data !== undefined) {
    return <Image src={query.data} fallback={props.fallback} />;
  }

  return null;
};

export default CachedSignedImage;
